<template>
  <div>
    <div class="row">
      <div class="col-md-12 header-row">
        <h3 class="heading semi-bold">Shirt Galleries</h3>
        <div class="row">
          <div class="col-md-2">
            <label>Timezone</label>
            <v-select
              :options="timezones"
              v-model="selectedTimezone"
              :reduce="(timezone) => timezone.value"
              label="label"
            ></v-select>
          </div>
          <div class="col-md-6">
            <div class="loading alert alert-warning" v-if="loading">
              <i class="fa fa-circle-o-notch fa-spin"></i> {{ loadingMessage }}
            </div>
          </div>
          <div class="col-md-4">
              <label>Search</label>
            <input
              type="text"
              class="form-control"
              placeholder="Shirt ID ..."
              @keyup="filterShirts($event.target.value)"
            />
          </div>
        </div>
      </div>
      <div class="col-md-12 shirt-gallery">
        <div
          class="row flex"
          v-for="(group, groupIndex) in data"
          :key="groupIndex"
        >
          <div
            v-bind:class="['col-md-12', { 'has-current': group.hasCurrent }]"
            @click="toggleGroup(groupIndex)"
          >
            <h4 class="shirt-group-title text-bold">
              <i
                class="fa fa-minus-circle"
                aria-hidden="true"
                v-if="group.showContent"
              ></i>
              <i class="fa fa-plus-circle" aria-hidden="true" v-else></i>
              {{ group.title }} -
              <span class="text-muted">({{ group.shirts.length }})</span>
            </h4>
          </div>
          <div v-if="group.showContent">
            <div
              class="col-md-3"
              v-for="(shirt, shirtIndex) in group.shirts"
              :key="shirtIndex"
              @click="showUpdateDialog(groupIndex, shirtIndex)"
            >
              <gallery-card :shirt="shirt" />
            </div>
          </div>
        </div>
        <div class="alert alert-warning" v-if="loading === false && Object.keys(data).length === 0">
         No shirt fits the entered order number.
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold">Set shirt of the week</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="row">
              <div class="col-md-6 modal-image-container">
                <img
                  :src="formData.image_url"
                  class="image"
                  alt=""
                  v-if="formData.image_url"
                />
                <img
                  src="/assets/img/fabric-placeholder.png"
                  class="image"
                  alt=""
                  v-else
                />
              </div>
              <div class="col-md-6">
                <h4>{{ formData.title }}</h4>
                <div class="form-group">
                  <label for="">Start date </label>
                  <VueCtkDateTimePicker
                    format="YYYY-MM-DD HH:mm:ss"
                    v-model="formData.start_date"
                    label=""
                  >
                  </VueCtkDateTimePicker>
                  <small v-if="errors.start" class="form-text text-danger">{{
                    errors.start.join(" ")
                  }}</small>
                </div>
                <div class="form-group">
                  <label for="">End date </label>
                  <VueCtkDateTimePicker
                    format="YYYY-MM-DD HH:mm:ss"
                    v-model="formData.end_date"
                    label=""
                  >
                  </VueCtkDateTimePicker>
                  <small v-if="errors.end" class="form-text text-danger">{{
                    errors.end.join(" ")
                  }}</small>
                </div>
                <p class="text-warning">
                  <strong>* Selected timezone {{ selectedTimezone }} </strong>
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer" v-if="isReadOnlyUser">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
          <div class="modal-footer" v-else>
            <button
              v-if="formData.start_date"
              type="button"
              class="btn btn-danger pull-left"
              @click="deleteShirtOfTheWeek()"
            >
              Remove from SOTW
            </button>
            <button
              v-else
              type="button"
              class="btn btn-danger pull-left"
              disabled
            >
              Remove from SOTW
            </button>
            <button
              type="button"
              class="btn btn-danger pull-left"
              @click="removeFromGallery()"
            >
              Remove from Gallery
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="setShirtOfTheWeek()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import GalleryCard from "./components/GalleryCard";
import Datepicker from "vuejs-datepicker";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
  components: {
    Datepicker,
    GalleryCard,
    VueCtkDateTimePicker,
  },
  data() {
    return {
      galleries: [],
      data: [],
      dataKeys: [],
      errors: {},
      shirtId: null,
      isReadOnlyUser: false,
      formData: {
        id: null,
        start_date: null,
        end_date: null,
        sow: false,
      },
      timezones: [
        { value: "UTC", label: "Server Time" },
        { value: "Europe/Berlin", label: "Germany" },
        { value: "Asia/Bangkok", label: "Thailand" },
      ],
      selectedTimezone: "Europe/Berlin",
      loading: false,
      loadingMessage: "",
      originalShirtList: []
    };
  },
  async mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    await this.getGalleries();
  },
  methods: {
    async getGalleries() {
      /**
       * Get the list of shirt galleries, order by:
       * - the shirt of the week FIRST [selected_as_sotw:desc]
       * - next shirt of the week > [sotw_start_date:asc]
       * - lastest added gallery > [gallery_added_date:desc]
       */

      this.showLoadingMessage("Loading the list of shirts, please wait ...");

      try {
        let results = await axios.get(
          "/v2/shirt_orders/gallery?sort=gallery_added_date:desc&is_backend=true"
        );
        this.all = results.data.data.collection;
        this.loadShirts();
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        }
      }

      this.hideLoadingMessage();
    },
    loadShirts() {
      /**
       *  Set the default image url
       */

      let shirts = [];

      let dateOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: this.selectedTimezone,
      };

      for (let index in this.all) {
        let shirt = Object.assign({}, this.all[index]);
        shirt.image_url = this.getShirtImage(this.all[index]);

        // Convert server datetime to selected timezone

        /**
         * Use sotw_end_date, sotw_start_date instead of the sotw_dates object, because they are in UTC timezone
         * (server timezone), therefore, easier to convert to the user-selected timezone
         */
        if (shirt.sotw_start_date !== null) {
          shirt.sotw_start_date = this.convertUTCDatetime(
            shirt.sotw_start_date,
            this.selectedTimezone
          );
        }

        if (shirt.sotw_end_date !== null) {
          shirt.sotw_end_date = this.convertUTCDatetime(
            shirt.sotw_end_date,
            this.selectedTimezone
          );
        }

        shirt.gallery_added_date = this.convertUTCDatetime(
          shirt.gallery_added_date,
          this.selectedTimezone
        );

        shirts.push(shirt);
      }

      this.originalShirtList = shirts;
      this.data = this.groupShirtsByWeek(this.originalShirtList);
    },
    /**
     * This function group the list of shirts by week.
     * The start of the week (Monday) is used as a grouping key.
     */
    groupShirtsByWeek(shirts) {
      let groups = shirts.reduce((shirtGroup, shirt) => {
        let groupTitle = "Unscheduled";
        let groupKey = Number.MAX_SAFE_INTEGER - 1;

        const uploadDate = new Date(shirt.gallery_added_date);

        // Get the start of the week (Monday)
        let day = uploadDate.getDay(),
          diff = uploadDate.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday

        let startOfTheWeek = new Date(uploadDate.setDate(diff));

        // Use midnight time as grouping key
        startOfTheWeek.setHours(0, 0, 0);

        // Use the start of the week as grouping key and title
        groupKey = startOfTheWeek.getTime();
        groupTitle = startOfTheWeek.toLocaleDateString("en-GB");

        // Get the end of the week (Sunday)
        let endOfTheWeek = new Date(startOfTheWeek);
        endOfTheWeek.setDate(endOfTheWeek.getDate() + 6);
        groupTitle =
          "From " +
          groupTitle +
          " to " +
          endOfTheWeek.toLocaleDateString("en-GB");

        // Create the group if it does not exists yet
        if (!shirtGroup[groupKey]) {
          shirtGroup[groupKey] = {
            title: groupTitle, // Title of the group
            shirts: [], // shirts inside the group
            showContent: false, // Tell if the shirts inside the group are displayed or not
            hasCurrent: false,
          };
        }

        // Add the shirt into his group
        shirtGroup[groupKey].shirts.push(shirt);

        /**
         * If the shirt is a current SOTW, force it's group to display it's content,
         * and mark it as 'has-current' for styling purpose
         */
        if (shirt.is_current_sotw) {
          shirtGroup[groupKey].showContent = true;
        }

        return shirtGroup;
      }, {});

      return Object.keys(groups)
          .sort()
          .reverse()
          .reduce((obj, key) => {
              obj[key] = groups[key];
              return obj;
          }, {});
    },
    async setShirtOfTheWeek() {
      /**
       * Prevent any operation when the list of shirt is still loading
       */
      if (this.loading) {
        return;
      }

      const data = {
        id: this.formData.id,
        start: this.getFormattedDate(this.formData.start_date),
        end: this.getFormattedDate(this.formData.end_date),
        timezone: this.selectedTimezone,
      };
      /**
       *
       */
      try {
        let result = await axios.put("/v2/shirt_orders/gallery/sow", data);
        if (result.data.status) {
          toastr.success("Shirt gallery successfully updated");
          hide_modal("#modal-box");
          this.getGalleries();
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error("There was an error updating the shirt gallery");
        }
      }
    },
    async deleteShirtOfTheWeek() {
      /**
       * Prevent any operation when the list of shirt is still loading
       */
      if (this.loading) {
        return;
      }

      const data = {
        id: this.formData.id,
        start: null,
        end: null,
        timezone: this.selectedTimezone,
      };
      /**
       *
       */
      try {
        let result = await axios.put("/v2/shirt_orders/gallery/sow", data);
        if (result.data.status) {
          toastr.success("Shirt gallery successfully updated");
          hide_modal("#modal-box");
          this.getGalleries();
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error("There was an error updating the shirt gallery");
        }
      }
    },

    async removeFromGallery() {
      if (
        await ezy.confirm(
          "Are you sure to remove this shirt from the gallery?",
          "Remove from gallery"
        )
      ) {
        try {
          let result = await axios.delete(
            "/v2/shirt_orders/gallery/" + this.formData.id
          );
          if (result.data.status) {
            toastr.success("Shirt successfully removed from gallery");
            hide_modal("#modal-box");
            this.getGalleries();
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            this.errors = error.response.data.errors;
            toastr.error(
              "There was an error removing the shirt from the gallery"
            );
          }
        }
      }
    },

    /**
     * Toggle the visibility of a shirt group
     */
    toggleGroup(groupIndex) {
      this.data[groupIndex].showContent = !this.data[groupIndex].showContent;
    },
    showUpdateDialog(groupIndex, shirtIndex) {
      /**
       * Prevent any operation when the list of shirt is still loading
       */
      if (this.loading) {
        return;
      }

      let shirt = this.data[groupIndex].shirts[shirtIndex];
      this.formData = {
        id: shirt.id,
        title: shirt.shirt_title,
        start_date: shirt.sotw_start_date,
        end_date: shirt.sotw_end_date,
        image_url: shirt.image_url,
      };
      this.shirtId = shirt.id;
      this.errors = {};
      show_modal("#modal-box");
    },
    /**
     * Get the shirt image
     */
    getShirtImage(shirt) {
      let variants = shirt.image_variants;
      if (variants.length > 0) {
        let mobile = null;
        let main = null;
        for (var i = variants.length - 1; i >= 0; i--) {
          let variant = variants[i];
          if (mobile === null && variant.size === "mobile") {
            mobile = variant.image_url;
          }
          if (main === null && variant.size === "main") {
            main = variant.image_url;
          }
        }
        return mobile ? mobile : main;
      } else {
      }
    },
    /**
     * Get the formatted from user input
     */
    getFormattedDate(date) {
      if (date instanceof Date) {
        return date.toISOString().slice(0, 10);
      } else {
        return date;
      }
    },
    /**
     * Filter the list of search by matching the search term with the shirt IDs.
     * @param search
     */
    filterShirts(search) {
      if (search !== "") {
        const shirts = this.originalShirtList.filter((shirt) => {
            return shirt.id.toString().includes(search);
        });
        this.data = this.groupShirtsByWeek(shirts);
      } else {
        this.data = this.groupShirtsByWeek(this.originalShirtList);
      }
    },
    /**
     * Convert a string date from UTC timezone to another timezone
     *
     * Input formats:
     *
     * dateString   => a string in the following format YYYY-MM-DD HH:mm:ss
     * timezone 	=> a string. Ex: UTC, Asia/Bangkok, Europe/Berlin ...
     *
     * Output format: YYYY-MM-DD HH:mm:ss
     */
    convertUTCDatetime(dateString, timezone) {
      // Force the date to UTC
      dateString = dateString.replace(/ /g, "T") + "Z";
      let date = new Date(dateString);

      /**
       * Convert the date to the following format:  DD/MM/YYYY, HH:mm:ss (Ex: 02/07/2021, 22:56:21)
       * and specified timezone (Ex: Europe/Berlin)
       */
      let formated = date.toLocaleString("en-GB", {
        timeZone: timezone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });

      /**
       * Extract the date components so that we can reformat it to the desired output format
       *
       * The matchAll method will output the following nested array
       *
       * [["02/07/2021, 22:56:21", "02", "07", "2021", "22", "56", "21", index: 0, input: "02/07/2021, 22:56:21", groups: undefined]]
       */
      const parts = [
        ...formated.matchAll(/(\d+)\/(\d+)\/(\d+),\s(\d+):(\d+):(\d+)/g),
      ];

      /**
       * Finally recompose the finale format
       */
      return (
        parts[0][3] +
        "-" +
        parts[0][2] +
        "-" +
        parts[0][1] +
        " " +
        parts[0][4] +
        ":" +
        parts[0][5] +
        ":" +
        parts[0][6]
      );
    },
    showLoadingMessage(message) {
      this.loading = true;
      this.loadingMessage = message;
    },
    hideLoadingMessage() {
      this.loading = false;
      this.loadingMessage = "";
    },
  },
  watch: {
    selectedTimezone() {
      if (this.selectedTimezone !== null) {
        this.loadShirts();
      }
    },
  },
};
</script>
<style scoped>
.shirt-gallery {
  margin-top: 25px;
}
.modal-image-container img {
  max-width: 100%;
}
.modal-image-container h4 {
  font-weight: 600;
  font-size: 17px;
}
.shirt-of-the-week {
  float: left;
  margin-right: 15px;
  margin-top: 4px;
}
.shirt-group-title {
  background-color: white;
  padding: 10px;
  cursor: pointer;
}
.has-current .shirt-group-title {
  background-color: orange;
  color: white;
}
.has-current .shirt-group-title .text-muted {
  color: white;
}
.loading {
  margin-top: 25px;
  margin-bottom: 0;
}
</style>
